import { Modal as AntModal } from 'antd';
import type { ModalProps as AntModalProps } from 'antd';
import type React from 'react';

import { withAuthGuard } from '../../auth';
import type { AuthProps } from '../../auth';

export type ModalProps = AntModalProps & AuthProps;

const GuardedModal = withAuthGuard(AntModal, {
    defaultFallback: 'hide',
}) as unknown as React.ForwardRefExoticComponent<ModalProps & React.RefAttributes<HTMLDivElement>>;

/**
 * Themed, auth-gated pass-through of antd's `Modal`. Static helpers
 * (`confirm`/`info`/`success`/`error`/`warning`/`useModal`) are copied
 * through unchanged — they're imperative APIs with no `auth` prop to gate.
 */
export const Modal = Object.assign(GuardedModal, {
    confirm: AntModal.confirm,
    info: AntModal.info,
    success: AntModal.success,
    error: AntModal.error,
    warning: AntModal.warning,
    useModal: AntModal.useModal,
});
